import { useEffect, useState } from 'react'
import { BrowserRouter, useRoutes } from 'react-router-dom'
import { Toaster } from 'sonner'

import { ConfigProvider } from '@arco-design/web-react'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { wrapUseRoutes } from '@sentry/react'

import useAuthStore from './pages/auth/store'
import routes from './routes'
import { RootProvider } from './store'

import './App.css'

import { UI_COLOR_MODE_KEY } from './constants'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})
const useSentryRoutes = wrapUseRoutes(useRoutes)

function RouteElement() {
  const element = useSentryRoutes(routes as any)
  return element
}

function App() {
  const { initProviders } = useAuthStore()

  const [colorMode, setColorMode] = useState(
    localStorage.getItem(UI_COLOR_MODE_KEY),
  )
  useEffect(() => {
    function onColorModeChange() {
      const colorMode = localStorage.getItem(UI_COLOR_MODE_KEY)
      setColorMode(colorMode)
    }
    window.addEventListener('ColorModeChange', onColorModeChange)
    return () => {
      window.removeEventListener('ColorModeChange', onColorModeChange)
    }
  })

  useEffect(() => {
    initProviders()
  }, [initProviders])

  const componentConfig = {
    Card: {
      bordered: false,
    },
    List: {
      bordered: false,
    },
    Table: {
      border: false,
    },
  }
  return (
    <RootProvider>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider componentConfig={componentConfig}>
          <Toaster closeButton position="top-right" />
          <BrowserRouter>
            <RouteElement />
          </BrowserRouter>
        </ConfigProvider>
      </QueryClientProvider>
    </RootProvider>
  )
}

export default App
